import { setNotifications } from './actionCreator';
import { notificationsReducer } from './reducers';

const notificationsReducers = {
  notificationsState: notificationsReducer,
};

export { notificationsReducers, setNotifications };
